<template>
  <modal 
    :show.sync="show"
    modal-classes="modal-dialog-centered"
    @close="close">
    <div 
      slot="base-content" 
      class="card card-plain mb-0">
      <div class="modal-header justify-content-center">
        <button 
          type="button" 
          class="btn-sm close text-dark" 
          data-dismiss="modal" 
          aria-hidden="true"
          @click="close">
          <i class="now-ui-icons ui-1_simple-remove"/>
        </button>
        <div class="header header-primary text-center">
          <h4 class="font-weight-bold m-0">{{ title }}</h4>
        </div>
      </div>
      <div 
        class="modal-body" 
        v-html="content"/>
    </div>
  </modal>
</template>
<script>
	import moment from 'moment';
  import { Button, Modal } from '@/components';

  export default {
    components: {
      Modal
    },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Detail'
      },
      content: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        show: false
      };
    },
    watch: {
      open() {
        this.show = this.open;
      }
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }
</script>
